import React from 'react'
import styled from 'styled-components'

import { useStoreContext } from 'hooks/StoreContext'

import { color } from 'styles/colors'

type Props = {
  date: Date
  className?: string
}

const HomeownerDayNotification = ({ date, className }: Props) => {
  const { homeownerAlerts } = useStoreContext()

  if (!homeownerAlerts?.alertedOnDates?.includes(date.toISOString().split('T')[0])) {
    return null
  }

  return (
    <S.HomeownerLastNotified className={className}>Customer notified about an alert</S.HomeownerLastNotified>
  )
}

const S = {
  HomeownerLastNotified: styled.div`
    color: ${color('homeownerAlertText')};
    font-style: italic;
    margin-left: 5px;
  `
}

export default HomeownerDayNotification
